import { _ } from "libs";

import React, { useEffect, useContext, useState } from "react";
import ReservationPageContext from "./reservationPageContext";
import SubPageLayout from "./subPageLayout";
import { PaymentMethod } from "../../../types";
import cx from "classnames";

const PaymentSelect = () => {
	const pageContext = useContext(ReservationPageContext);
	const {
		setPage,
		reservation: { cards, context, params, selectedCard },
		getReservationContext,
		goBack,
		selectCard,
	} = pageContext;

	const [showAddCard, setShowAddCard] = useState(false);

	useEffect(() => {
		context.paymentOptions.forEach((option) => {
			if (option.paymentMethod === PaymentMethod.CreditCard && option.available === true) {
				setShowAddCard(true);
			}
		});
	}, []);

	const cellClassName = (selectedCell: boolean) => {
		return cx("cell selectableCell", { selectedCell });
	};

	return (
		<SubPageLayout title={_("bookingWizard.payment.heading")} extraClass="selectPaymentMethod">
			<div className="wizardBody">
				<div className="table dominantLabels">
					{context.paymentOptions.map((option) => {
						if (option.available) {
							if (option.paymentMethod === PaymentMethod.CreditCard) {
								return cards.map((card) => (
									<div
										key={card.cardId}
										className={cellClassName(card.cardId === selectedCard)}
										onClick={() => {
											selectCard(card.cardId);
											getReservationContext({ paymentMethod: PaymentMethod.CreditCard });
											goBack();
										}}
									>
										<div className="tableRow">
											<div className="tableRowIcon" />
											<div className="tableRowLabel">
												{_("bookingWizard.payment.creditcard.label")}
											</div>
											<div className="tableRowValue horizontal">
												<div className={`creditCardIcon ${card.brand.toLowerCase()}`} />
												<div className="creditCardEnding">...{card.last4}</div>
											</div>
										</div>
									</div>
								));
							} else {
								return (
									<div
										key={option.paymentMethod}
										className={cellClassName(option.paymentMethod === params.paymentMethod)}
										onClick={() => {
											getReservationContext({ paymentMethod: option.paymentMethod });
											goBack();
										}}
									>
										<div className="tableRow">
											<div className="tableRowIcon" />
											<div className="tableRowLabel">
												{_(`bookingWizard.payment.${option.paymentMethod}.label`)}
											</div>
											<div className="tableRowValue horizontal">
												{[PaymentMethod.GCWallet, PaymentMethod.Balance].includes(
													option.paymentMethod as PaymentMethod | null
												) ? (
													<div className="creditBalance">{`${option.note} ${option.currency}`}</div>
												) : null}
											</div>
										</div>
									</div>
								);
							}
						}
					})}
				</div>
				{showAddCard ? (
					<div className="addCard">
						<a
							className="link blue"
							onClick={() => {
								setPage("addCard");
							}}
						>
							{_("bookingWizard.payment.addCardLink")}
						</a>
					</div>
				) : null}
			</div>
		</SubPageLayout>
	);
};

export default PaymentSelect;
